export default "__VITE_ASSET__51Y6DCLw__"